<template>
    <div class="vh-100 d-flex flex-column justify-content-center m-0">
        <MainHeader />
        <main class="height-content d-flex flex-column align-items-center">
            <AppBreadcrumb />
            <slot />
        </main>
        <MainFooter />
    </div>
</template>

<script setup>
import MainHeader from '@/components/layoutParts/MainHeader.vue';
import MainFooter from '@/components/layoutParts/MainFooter.vue';
import AppBreadcrumb from '@/components/layoutParts/AppBreadcrumb.vue';

</script>

<style scoped>
.height-content {
    min-height: 87%;
    max-height: 87%;
    overflow-y: auto;
    overflow-x: hidden;
}

@media only screen and (max-width: 575px)  {
    .height-content { 
        max-height: 81.5% !important; 
        min-height: 81.5% !important; 
    }
}

@media only screen and (max-height: 750px) {
    .height-content { 
        max-height: 76% !important; 
        min-height: 76% !important; 
    }
}
</style>